import React from 'react';
import { TableRow } from '@getsynapse/design-system';
import { CapacityManagementDrillDownItem } from 'types/store/normalized/insightsDrillDown';
import UserAvatar from 'Atoms/UserAvatar';

type CapacityManagementDrillDownTableRowProps = {
  item: CapacityManagementDrillDownItem;
};

const CapacityManagementDrillDownTableRow: React.FC<
  CapacityManagementDrillDownTableRowProps
> = ({ item }) => {
  return (
    <TableRow
      id={item.id}
      className='group cursor-pointer'
      cells={[
        {
          content: (
            <div className='flex items-center'>
              <UserAvatar
                size='small'
                user={{
                  avatar_url: item.user_data.avatar_url,
                  status: item.user_data.status,
                  data: {
                    firstName: item.user_data.first_name,
                    lastName: item.user_data.last_name,
                  },
                }}
                className='mr-2.5'
              />
              {`${item.user_name}`}
            </div>
          ),
        },
        {
          content: item.user_type || '',
        },
        {
          content: item.task_number || '',
        },
        {
          content: item.task_name || '',
        },
        {
          content: item.task_status || '',
        },
        {
          content: item.task_type || '',
        },
        {
          content: item.allocated_hours_in_range || 0,
        },
        {
          content: item.actual_hours_in_range || 0,
        },
        {
          content: item.project_title || '',
        },
        {
          content: (
            <>
              {item.business_units
                ?.map((business_unit) => business_unit.title)
                .join(', ') || ''}
            </>
          ),
        },
        {
          content:
            item.programs?.map((program) => program.title).join(', ') || '',
        },
        {
          content:
            item.project_learning_teams?.map((team) => team.name).join(', ') ||
            '',
        },
        {
          content:
            item.user_learning_teams?.map((team) => team.name).join(', ') || '',
        },
      ]}
    />
  );
};

export default CapacityManagementDrillDownTableRow;
